// extracted by mini-css-extract-plugin
export default {"homeWrapper":"Home_homeWrapper__RjkxP","balanceWrapper":"Home_balanceWrapper__ZIREm","earningsWrapper":"Home_earningsWrapper__7W2WW"};